const vehicles = {
  table: {
    headers: {
      supplier: 'Flotas',
    },
    filters: {
      supplier: 'Flotas',
    },
  },

  form: {
    information: {
      details: {
        fields: {
          suppliers: 'Flotas',
        },
      },

      suppliers: {
        header: 'Flotas',
        fields: {
          suppliers: 'Flotas',
        },
      },
    },
  },
};

export default vehicles;
